import api from '../config/api';

const categoryService = {
  async getAll() {
    const response = await api.get('/api/categories');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/api/categories/${id}`);
    return response.data;
  },

  async create(categoryData) {
    const response = await api.post('/api/categories', categoryData);
    return response.data;
  },

  async update(id, categoryData) {
    const response = await api.put(`/api/categories/${id}`, categoryData);
    return response.data;
  },

  async delete(id) {
    const response = await api.delete(`/api/categories/${id}`);
    return response.data;
  },
};

export default categoryService;
